import {Component, Input} from '@angular/core';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-home-why-card-yellow',
  imports: [],
  templateUrl: './home-why-card-yellow.component.html',
})
export class HomeWhyCardYellowComponent {

  @Input()
  reduced = true
  protected readonly environment = environment;
}
